'use client'

import dynamic from 'next/dynamic'

export const StickyBarClient = dynamic(
  () => import('./stickybar').then(module => module.StickyInfo),
  {
    ssr: false,
    loading: () => null,
  },
)
